// ShapeDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import ShapeForm from './ShapeForm'
import { UniversalDropDown } from "@fileops/swmm-react"
import { XsectTypeWords } from "@fileops/swmm-node"
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function ShapeDialog({ model, setModel, targetType, target }) {
  const [shapeType, setShapeType] = useState(model.XSECTIONS && model.XSECTIONS[target] && model.XSECTIONS[target].Shape?model.XSECTIONS[target].Shape:'')
  const [submodel, setSubmodel] = useState()
  
  // Create a submodel for this editor interface.
  useEffect(()=>{
    let XSECTIONS = {}

    if(model.XSECTIONS && model.XSECTIONS[target] && shapeType === model.XSECTIONS[target].Shape){
      XSECTIONS = {
        [target]: {
          ...model.XSECTIONS[target]
        }
      }
    } else {
      switch(shapeType){
        case 'CUSTOM':
          XSECTIONS = {
            [target]:{
              swmmType: 'CUSTOM',
              Shape: 'CUSTOM',
              Geom1: model.XSECTIONS[target].Geom1,
              Curve: '0',
              Geom2: model.XSECTIONS[target].Geom2, // not used, but necessary
              Geom3: model.XSECTIONS[target].Geom3, // not used, but necessary
              Barrels: model.XSECTIONS[target].Barrels // not necessary, but used
            }}
          break;
        case 'IRREGULAR': 
          XSECTIONS = {
            [target]:{
              swmmType: 'IRREGULAR',
              Shape: 'IRREGULAR',
              Tsect: ''
            }}
          break; 
        case 'STREET': 
          XSECTIONS = {
            [target]:{
              swmmType: 'STREET',
              Shape: 'STREET',
              Street: ''
            }}
          break;
        default: 
          XSECTIONS = {
            [target]:{
              swmmType: 'SHAPE',
              Shape: 'CIRCULAR', 
              Geom1: model.XSECTIONS[target].Geom1, 
              Geom2: model.XSECTIONS[target].Geom2, 
              Geom3: model.XSECTIONS[target].Geom3, 
              Geom4: model.XSECTIONS[target].Geom4, 
              Barrels: model.XSECTIONS[target].Barrels,
              Culvert: ''
            }}
          break;
    }}

    setSubmodel({
      XSECTIONS: XSECTIONS
    })
  },[shapeType])

  const saveEdits = () => {
    // Get the proper swmmType
    let swmmType = ''
    switch(shapeType){
      case 'CUSTOM':
        swmmType = 'CUSTOM'
        break;
      case 'IRREGULAR':
        swmmType = 'IRREGULAR'
        break;
      case 'STREET':
        swmmType = 'STREET'
        break;
      default:
        swmmType='SHAPE'
    }
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    setModel(prev => ({
      ...prev,
      XSECTIONS:{
        ...prev.XSECTIONS, 
        [target]: {
          ...cleanSub.XSECTIONS[target],
          swmmType: swmmType,
          Shape: shapeType
        }
      }
    }))
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(submodel){
    return(
      <>
      {
        <>
          <Typography id="modal-modal-title" variant="p4" >
            <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
              <label>Shape for Conduit {target}</label>
            </div>
          </Typography>
          <div>
            <Button fullWidth onClick={saveEdits} >Save Edits</Button>
          </div>
          <div style={{height: "280px", background:'black', overflowY: 'hidden', paddingBottom:"120px"}}>
            <UniversalDropDown 
              IDs={XsectTypeWords} 
              selectText={"Select a Shape Type"} 
              value={shapeType}
              onChange={(val)=>setShapeType(val)} >
            </UniversalDropDown>
            {
              targetType && 
              targetType in model && 
              target &&
              <ShapeForm model={submodel} setModel={setSubmodel} fullModel={model} shapeType={shapeType} target={target} />
            }
          </div>
          </>
        }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}